export const L10N = {
  ACTION_BACK: { id: 'core.action.back_login' },
  ACTION_CHANGE_PASSWORD: { id: 'core.action.change_login_password' },
  ACTION_MANAGE_ACCOUNT: { id: 'core.action.manage_account', defaultMessage: 'Log in' },
  ACTION_MODAL: { id: 'common.action.login', defaultMessage: 'Log in' },
  ACTION_MY_BOOKINGS: { id: 'core.action.my_bookings' },
  ACTION_PROFILE: { id: 'core.action.view_profile' },
  ACTION_RESET: { id: 'core.action.reset' },
  ACTION_SIGNUP: { id: 'core.action.signup' },
  CTA: { id: 'common.action.login' },
  CTA_RESET: { id: 'core.action.cta_reset' },
  CTA_LOGOUT: { id: 'common.action.logout' },
  FORM_DESCRIPTION: { id: 'core.label.form_description' },
  FORM_RESET_DESCRIPTION: { id: 'core.label.form_reset_description' },
  EMAIL_LABEL: { id: 'common.label.email' },
  LEVEL: { id: 'core.label.level' },
  PASSWORD_LABEL: { id: 'common.label.password' },
  TITLE: { id: 'common.action.login' },
  TITLE_RESET: { id: 'core.action.reset' },
  TITLE_WITH_SIGNUP: { id: 'core.label.title_session' },
  NOTIFICATION_ERROR: { id: 'common.notification.error_unknown' },
  NOTIFICATION_FINISH_SIGNUP_TITLE: { id: 'core.notification.activation_success' },
  NOTIFICATION_FINISH_SIGNUP_DESCRIPTION: { id: 'core.notification.finish_signup_description' },
  NOTIFICATION_FINISH_SIGNUP_ERROR: { id: 'core.notification.validation_error' },
  NOTIFICATION_SUCCESS_RESET: { id: 'core.notification.success_reset' },
};
